import { render, staticRenderFns } from "./PageData.vue?vue&type=template&id=1878031c&"
import script from "./PageData.vue?vue&type=script&lang=js&"
export * from "./PageData.vue?vue&type=script&lang=js&"
import style0 from "./PageData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports